var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2068E37F-1207-4F9D-80B3-381CE7550D33") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,3.93272318 L9.7900075,0.142715683 C9.98029508,-0.0475718942 10.2888122,-0.0475718942 10.4790998,0.142715683 L11.8572843,1.52090023 C12.0475719,1.7111878 12.0475719,2.01970492 11.8572843,2.2099925 L8.06727682,6 L11.8572843,9.7900075 C12.0475719,9.98029508 12.0475719,10.2888122 11.8572843,10.4790998 L10.4790998,11.8572843 C10.2888122,12.0475719 9.98029508,12.0475719 9.7900075,11.8572843 L6,8.06727682 L2.2099925,11.8572843 C2.01970492,12.0475719 1.7111878,12.0475719 1.52090023,11.8572843 L0.142715683,10.4790998 C-0.0475718942,10.2888122 -0.0475718942,9.98029508 0.142715683,9.7900075 L3.93272318,6 L0.142715683,2.2099925 C-0.0475718942,2.01970492 -0.0475718942,1.7111878 0.142715683,1.52090023 L1.52090023,0.142715683 C1.7111878,-0.0475718942 2.01970492,-0.0475718942 2.2099925,0.142715683 L6,3.93272318 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "portfolio-builder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2e-search",
    transform: "translate(-1405.000000, -118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modal",
    transform: "translate(1040.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(1.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/close",
    transform: "translate(364.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ic_close",
    fill: "#8A8888",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Color",
    mask: "url(#mask-2)",
    fill: "#255EBA"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.000000, -6.000000)",
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic_close.5c839eb72a0dc925f443a6cf7d7e4672.svg";
export { ForwardRef as ReactComponent };